// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `You won:`
};

const de_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Du hast gewonnen:`
};

const es_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Ganaste:`
};

const fr_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Vous avez gagné :`
};

const fi_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Voitit:`
};

const hi_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `आपने जीता:`
};

const ja_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `おめでとうございます：`
};

const nl_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Je hebt gewonnen:`
};

const pt_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Você ganhou:`
};

const ro_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Ai câștigat:`
};

const th_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `คุณชนะ:`
};

const ur_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `آپ نے جیتا:`
};

const zh_hant1_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `您獲得了：`
};

const da_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Du vandt:`
};

const it_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Hai vinto:`
};

const vn_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Bạn đã thắng:`
};

const ko_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `당첨되었습니다:`
};

const tr_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Kazandınız:`
};

const lv_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Jūs uzvarējāt:`
};

const ar_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `لقد فزت:`
};

const bs_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Dobili ste:`
};

const sl_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Zmagali ste:`
};

const id_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Anda menang:`
};

const sv_widget_you_won = /** @type {(inputs: {}) => string} */ () => {
	return `Du vann:`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_you_won = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_you_won(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_you_won", locale)
	if (locale === "en") return en_widget_you_won(inputs)
	if (locale === "de") return de_widget_you_won(inputs)
	if (locale === "es") return es_widget_you_won(inputs)
	if (locale === "fr") return fr_widget_you_won(inputs)
	if (locale === "fi") return fi_widget_you_won(inputs)
	if (locale === "hi") return hi_widget_you_won(inputs)
	if (locale === "ja") return ja_widget_you_won(inputs)
	if (locale === "nl") return nl_widget_you_won(inputs)
	if (locale === "pt") return pt_widget_you_won(inputs)
	if (locale === "ro") return ro_widget_you_won(inputs)
	if (locale === "th") return th_widget_you_won(inputs)
	if (locale === "ur") return ur_widget_you_won(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_you_won(inputs)
	if (locale === "da") return da_widget_you_won(inputs)
	if (locale === "it") return it_widget_you_won(inputs)
	if (locale === "vn") return vn_widget_you_won(inputs)
	if (locale === "ko") return ko_widget_you_won(inputs)
	if (locale === "tr") return tr_widget_you_won(inputs)
	if (locale === "lv") return lv_widget_you_won(inputs)
	if (locale === "ar") return ar_widget_you_won(inputs)
	if (locale === "bs") return bs_widget_you_won(inputs)
	if (locale === "sl") return sl_widget_you_won(inputs)
	if (locale === "id") return id_widget_you_won(inputs)
	if (locale === "sv") return sv_widget_you_won(inputs)
	return "widget_you_won"
};